import { RecoveryApi } from './api';

// S'assurer que l'URL de base ne se termine pas par un slash
const baseUrl = (process.env.REACT_APP_API_URL || "http://localhost:3000").replace(/\/+$/, "");
const recoveryApi = new RecoveryApi(undefined, baseUrl);

export const requestPasswordReset = async (email: string) => {
  try {
    const response = await recoveryApi.apiPasswordResetRequestPost({ email });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.error || 'Erreur lors de la demande de réinitialisation');
    }
    throw new Error('Erreur de connexion');
  }
};

export const verifyPasswordResetCode = async (email: string, code: string) => {
  try {
    const response = await recoveryApi.apiPasswordResetVerifyPost({ email, code });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.error || 'Code incorrect');
    }
    throw new Error('Erreur de connexion');
  }
};

export const resetPassword = async (email: string, code: string, newPassword: string) => {
  try {
    const response = await recoveryApi.apiPasswordResetResetPost({ 
      email, 
      code, 
      newPassword 
    });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.error || 'Erreur lors de la réinitialisation du mot de passe');
    }
    throw new Error('Erreur de connexion');
  }
}; 